<template>
	<div class="invoicehit d-inline-block">
		<a-popover
			title="Listado de vencimientos"
			trigger="click"
			placement="bottom"
			overlay-class-name="invoicehit"
		>
			<a-tag
				type="primary"
				:color="$colors.primary"
				class="pointer"
			>
				<fa-icon
					:icon="['fas','eye']"
					class="mr-2"
				/>{{ data.Vencimientos.length }}
			</a-tag>
			<div slot="content">
				<table class="table table-hit table-striped">
					<thead>
						<tr>
							<th>Vencimiento</th>
							<th>Importe</th>
							<th>Estado</th>
						</tr>
					</thead>
					<tbody>
						<tr
							v-for="(hit, index) in data.Vencimientos"
							:key="index"
						>
							<td>{{ hit.VencimientoFecha | moment('LL') }}</td>
							<td>{{ hit.VencimientoImporte }} €</td>
							<td><invoice-hit-status :data="hit" /></td>
						</tr>
					</tbody>
				</table>
			</div>
		</a-popover>
	</div>
</template>

<script>
export default {
	name: 'InvoiceHitsList',
	props: {
		data: {
			type: Object,
			required: true
		}
	}
};
</script>

<style lang="scss" >
	.invoicehit{
		.ant-popover-title{
			padding: 10px  !important;
			background: $gray-2;
			font-weight: bold;
			font-family: Rubik;
		}

		.ant-popover-inner-content{
			padding: 0 !important;
		}

		.table.table-hit{
			margin-bottom: 0;
			border: 0;

			th, td, span{
				vertical-align: middle;
				font-size: 12px !important;
			}
		}
	}
</style>
